import React from 'react';


const CookieConsent = ({ onAccept }) => (
  <div
    className="site-notification cookie_usage"
    data-name="cookie_usage"
    style={{
      position: 'relative',
      backgroundColor: 'rgb(171, 201, 236)',
      color: 'rgb(37, 37, 37)',
    }}
  >
    <style
      dangerouslySetInnerHTML={{
        __html:
                    '.site-notification .container { padding-bottom: 10px;padding-top: 10px; }.site-notification a.btn { display:block; }@media (min-width: 550px) { .site-notification p { margin-right: 100px; }.site-notification a.btn { display:inline-block;position: absolute;top: 50%;right:10px;margin-top:-15px; }.site-notification .container { position: relative; }}',
      }}
    />
    <div className="container">
      <p
        style={{
          marginBottom: 0,
          marginTop: 0,
          padding: '10px 30px 10px 0',
        }}
      >
        We use cookies to understand how you use our site and to improve
        your experience. This includes personalizing content and
        advertising. To learn more,{' '}
        <a href="/cookie-policy" style={{ color: 'rgb(34, 107, 183)' }}>
          click here
        </a>
        . By continuing to use our site, you accept our{' '}
        <a href="/cookie-policy" style={{ color: 'rgb(34, 107, 183)' }}>
          use of cookies
        </a>
        , revised{' '}
        <a
          href="/privacy_policy"
          style={{ color: 'rgb(34, 107, 183)' }}
        >
          Privacy Policy
        </a>
        , and{' '}
        <a
          href="/terms_of_service"
          style={{ color: 'rgb(34, 107, 183)' }}
        >
          Terms of Use
        </a>
        .
      </p>
      <a className="btn btn-success" href="/consent?n=cookie_usage" onClick={onAccept}>
        Accept
      </a>
    </div>
  </div>
);

export default CookieConsent;
